import { Opportunity } from "@entities";
import { type HyperTableFilter } from "@shared/frontend/hyper-table";
import { TeamsSelect } from "../../../components/teams-select";
import { opportunityAgeRangeFilter } from "../opportunity-age-range-filter";

const filters: HyperTableFilter<Opportunity>[] = [
  {
    id: "teams",
    icon: "literal",
    caption: "פרויקטים",
    renderFilter: ({ onSave, meta }) => {
      const { teams } = meta;
      return (
        <TeamsSelect
          id="opportunities-table"
          value={teams as string[]}
          onChange={(teams) =>
            onSave({
              value: teams.length
                ? Opportunity.hyperFilter({
                  teams: {
                    $some: {
                      teamId: teams as string[],
                    },
                  },
                })
                : {},
              meta: { teams },
            })
          }
        />
      );
    },
  },
  {
    fieldName: "endDate",
    id: "endDate",
  },
  {
    fieldName: "title",
    id: "title",
  },
  {
    fieldName: "location",
    id: "location",
  },
  {
    fieldName: "comments",
    id: "comments",
  },
  opportunityAgeRangeFilter,
];

export default filters;
